export const getRequestUrl = () => {
  const url = new URL(window.location.href);
  url.searchParams.delete('transactionId');

  return url.href;
};
